import React from 'react';
import { ShieldAlert } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-ink py-20 px-4 border-t border-white/5" data-id="element-90">
      <div className="max-w-3xl mx-auto text-center" data-id="element-91">
        <div className="flex justify-center mb-8" data-id="element-92">
          <div className="w-24 h-24 bg-forest rounded-full flex items-center justify-center border-4 border-amber/30" data-id="element-93">
            <ShieldAlert className="w-12 h-12 text-amber" data-id="element-94" />
          </div>
        </div>

        <h2 className="font-display text-4xl md:text-5xl text-white mb-8 uppercase" data-id="element-95">
          Try Soccer Ready™ For 7 Days —{' '}
          <span className="text-amber" data-id="element-96">Completely Risk-Free</span>
        </h2>

        <p className="text-lg text-gray-300 leading-relaxed mb-8" data-id="element-97">
          We're so confident Soccer Ready™ will transform the way you coach
          that we're offering a full 7-day money-back guarantee. Download
          everything, go through the materials, run a session or two — and if
          you're not completely satisfied, just send us a message and we'll
          refund every cent.
        </p>

        <p className="text-lg text-white font-bold leading-relaxed" data-id="element-98">
          No questions asked. No hoops to jump through. You either love it or
          you don't pay for it.
        </p>
      </div>
    </section>;
}